module.exports = __webpack_public_path__ + "static/media/down_arrow.9f743d72.svg";